import { Pipe, PipeTransform } from '@angular/core';
import { formatDistanceToNowStrict, isValid } from 'date-fns';

@Pipe({
  name: 'dateFormat',
  standalone: true
})
export class DateFormatPipe implements PipeTransform {
  transform(date: Date | string | null | undefined): string {
    if (!date) {
      return '';
    }

    // Parse as-is: HTTP dates carry a local offset (dateTransformInterceptor), realtime pushes carry 'Z'.
    const parsed = new Date(date);
    if (!isValid(parsed)) {
      return '';
    }

    // Clock skew can put a fresh push slightly in the future; don't render "in 2 seconds".
    if (Date.now() - parsed.getTime() < 1000) {
      return 'Just now';
    }

    return formatDistanceToNowStrict(parsed, { addSuffix: true, roundingMethod: 'floor' });
  }
}
